<template>
  <a
    :href="link"
    class="card"
    :class="{ 'card--newsPage': newsPage }"
  >
    <article>
      <div class="card__imageContainer">
        <img
          :src="image"
          :alt="alt"
          class="card__image"
        >
      </div>
      <div class="card__container">
        <p class="card__title">
          <slot name="title" />
        </p>
        <c-text
          color="#43515A"
          size="xs"
          weight="400"
          align="left"
          class="card__text"
        >
          <slot name="text" />
        </c-text>
        <div class="card__info">
          <p
            v-for="(category, index) in categories"
            v-show="currentCategory === index"
            :key="index"
            class="card__category"
          >
            <slot
              name="category"
              :category="category"
            />
          </p>
          <p class="card__date">
            <slot name="date" />
          </p>
        </div>
      </div>
    </article>
  </a>
</template>

<script>
import CText from '@atoms/text/text.vue'

export default {
  name: 'card-news',
  components: {
    CText,
  },
  props: {
    link: {
      type: String,
    },
    image: {
      type: String,
    },
    alt: {
      type: String,
    },
    newsPage: {
      type: Boolean,
      default: false,
    },
    categories: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentCategory: 0,
    }
  },
  mounted() {
    if (this.categories.length > 0) {
      this.startCategoryRotation()
    }
  },
  beforeUnmount() {
    if (this.rotationInterval) {
      clearInterval(this.rotationInterval)
    }
  },
  methods: {
    startCategoryRotation() {
      this.rotationInterval = setInterval(() => {
        this.currentCategory = (this.currentCategory + 1) % this.categories.length
      }, 5000)
    },
  },
}
</script>

<style scoped lang="scss">
.card {
  display: flex;
  flex-direction: column;
  border: 0.063rem solid $neutral-04;
  background-color: $white;
  width: 100%;
  overflow: hidden;
  text-decoration: none;
  cursor: pointer;

  &--newsPage {
    border: none;
    @include screen-size('xl') {
      min-width: 366px;
    }

    & .card__container {
      padding: 2rem 0 1.5rem;

      @include screen-size('xlg') {
        padding: 2rem 0 1rem;
      }
    }
  }

  &__imageContainer {
    display: flex;
    overflow: hidden;
  }

  &__image {
    width: 100%;
    object-fit: cover;
    height: 16.25rem;
    transition: all 0.8s;

    &:hover {
      transform: scale(1.08);
    }
  }

  &__container {
    padding: 2rem 1rem 1.5rem;

    @include screen-size('xlg') {
      padding: 2rem 1rem 1rem;
    }
  }

  &__title {
    color: $neutral-02;
    font-size: 1rem;
    font-weight: 700;
    margin: 0 0 1rem;

    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;

    @include screen-size('xlg') {
      font-size: 1.5rem;
    }
  }

  &__text {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.875rem;
    margin-top: 3.25rem;
    gap: 0.2rem;

    @include screen-size('xlg') {
      font-size: 1.25rem;
      margin-top: 2.5rem;
    }
  }

  &__category {
    @include font-telegraf(800);
    color: $blue-03;
  }

  &__date {
    color: $gray;
    font-weight: 500;
  }
}
</style>
